import ApiService from "./ApiService";
import {
	CriteriaRecomendationsDeleteRelationResponse,
	CriteriaRecomendationsGetResponse,
	CriteriaRecomendationsManifestationsDeleteRelationResponse,
	CriteriaRecomendationsManifestationsRelationsPostRequest,
	CriteriaRecomendationsManifestationsRelationsPostResponse,
	CriteriaRecomendationsPostRequest,
	CriteriaRecomendationsPostResponse,
	CriteriaRecomendationsPutRequest,
	CriteriaRecomendationsPutResponse,
	CriteriaRecomendationsRelationsPostRequest,
	CriteriaRecomendationsRelationsPostResponse,
} from "src/entities/CriteriaRecomendationEntity";

export const criteriaRecomendationQueryKeys = {
	recomendations: (id: string) => ["criteria", id, "recomendations"] as const,
};

export default class CriteriaRecomendationService extends ApiService {
	public async getRecomendations(criteriaId: number) {
		return await this.request.get<CriteriaRecomendationsGetResponse>(`/api/v1/criteria/${criteriaId}/recomendations`);
	}
	public async postRecomendation(data: CriteriaRecomendationsPostRequest) {
		return await this.request.post<CriteriaRecomendationsPostResponse>(`/api/v1/criteria/recomendations`, data);
	}
	public async putRecomendation(data: CriteriaRecomendationsPutRequest) {
		return await this.request.put<CriteriaRecomendationsPutResponse>(`/api/v1/criteria/recomendations`, data);
	}
	public async postRecomendationRelations(data: CriteriaRecomendationsRelationsPostRequest) {
		return await this.request.post<CriteriaRecomendationsRelationsPostResponse>(`/api/v1/criteria/recomendations/relations`, data);
	}
	public async deleteRecomendationRelation(criteriaId: number, recomendationId: number) {
		return await this.request.delete<CriteriaRecomendationsDeleteRelationResponse>(`/api/v1/criteria/${criteriaId}/recomendations/${recomendationId}/relations`);
	}
	public async postRecomendationManifestationRelations(data: CriteriaRecomendationsManifestationsRelationsPostRequest) {
		return await this.request.post<CriteriaRecomendationsManifestationsRelationsPostResponse>(`/api/v1/criteria/recomendations/manifestations/relations`, data);
	}
	public async deleteRecomendationManifestationRelation(recomendationId: number, manifestationId: number) {
		return await this.request.delete<CriteriaRecomendationsManifestationsDeleteRelationResponse>(`/api/v1/criteria/recomendations/${recomendationId}/manifestations/${manifestationId}/relations`);
	}
}
